/**
 * 次文件用于接口loading效果的定制接口忽略
 */

 /**
  * [<String>] String: serviceConfig.resources[key]
  */
const ignoreApiDmsList = [
  'inputShiftGCData',
  'getUploadExcelStatus',
  'batchSaveStoreShiftProgress',
  'batchSendStoreShiftProgress',
  'batchGCShiftProgress'
];
const ApiTack = new Set(ignoreApiDmsList);

export default ApiTack;



// WEBPACK FOOTER //
// core-build-local/plugs/ignoreService.js